export enum CancelationReasonTypeEnum {
    SALE = 'SALE',
    OPPORTUNITY = 'OPPORTUNITY',
}
